/**
 * Internal dependencies
 */
import WMUWCBundleChildProduct from "./child-product";

/**
 * 
 */
class WMUWCBundleChildProductVariable extends WMUWCBundleChildProduct {

	/**
	 * 
	 * @type HTMLSelectElement[]
	 */
	attributeSelectList = [];

	/**
	 * 
	 * @type Object
	 */
	variationAttributes = {};

	/**
	 * 
	 * @type Number
	 */
	variationId = 0;

	/**
	 * 
	 */
	constructor()
	{
		super();
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onAttributeChange = this.onAttributeChange.bind( this );
		this.onAttributeSelectReplaced = this.onAttributeSelectReplaced.bind( this );
	}

	/**
	 * 
	 * @param {HTMLSelectElement} select 
	 */
	addAttributeSelect( select )
	{
		this.attributeSelectList.push( select );

		if ( select.wmuSelect )
		{
			select.addEventListener( 'change', this.onAttributeChange );
		}
		else
		{
			select.addEventListener( 'replaced', this.onAttributeSelectReplaced );
		}
	}

	/**
	 * 
	 */
	getVariationData()
	{
		const data = {};

		for ( let i = 0, c = this.attributeSelectList.length; i < c; i++ )
		{
			data[ this.attributeSelectList[ i ].getAttribute( 'data-attribute_name' ) ] = this.attributeSelectList[ i ].value;
		}

		return data;
	}

	/**
	 * 
	 */
	isValid()
	{
		return ( this.variationId && ! this.isVariationNeedsRefresh() );
	}

	/**
	 * 
	 */
	isVariationNeedsRefresh()
	{
		let attributeName;
		let needsRefresh = false;
		let value;

		for ( let i = 0, c = this.attributeSelectList.length; i < c; i++ )
		{
			attributeName = this.attributeSelectList[ i ].getAttribute( 'data-attribute_name' );
			value = this.attributeSelectList[ i ].value;

			if ( ! value ) return false;

			if ( value != this.variationAttributes[ attributeName ] )
			{
				needsRefresh = true;
			}
		}

		return needsRefresh;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onAttributeChange( event )
	{
		if ( this.isVariationNeedsRefresh() )
		{
			document.dispatchEvent( new CustomEvent( 'wmuwc/bundleProduct/variationRefresh', {
				detail: {
					childProduct: this,
				}
			} ) );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onAttributeSelectReplaced( event )
	{
		event.detail.wmuSelect.selectElement.addEventListener( 'change', this.onAttributeChange );
		this.onAttributeChange( event );
	}

}

export default WMUWCBundleChildProductVariable;